import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const Opt = ({ v, cur, set, children, testid }) => (
  <label className={`flex items-start gap-3 rounded-lg border p-3 min-h-[48px] cursor-pointer ${cur === v ? "border-[#C9A961] bg-[#C9A961]/10" : "border-slate-200"}`}>
    <input type="radio" name="ms-when" className="mt-1" checked={cur === v} onChange={() => set(v)} data-testid={testid} />
    <span className="text-sm text-slate-800">{children}</span>
  </label>
);

export default function MilestoneAchieveDialog({ open, onOpenChange, title, today, first, onSave }) {
  const [when, setWhen] = useState("today");
  const [day, setDay] = useState("");
  useEffect(() => { if (open) { setWhen("today"); setDay(""); } }, [open]);
  const ok = when !== "date" || !!day;
  const save = () => onSave(when === "unknown" ? { date_unknown: true } : when === "date" ? { achieved_on: day } : {});
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100vw-1.5rem)] max-w-md" data-testid="milestone-achieve-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-[#0A1F44]">{first ? "When did you achieve this milestone?" : "When did you requalify?"}</DialogTitle>
          <DialogDescription>{title}</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Opt v="today" cur={when} set={setWhen} testid="milestone-when-today">Today</Opt>
          <Opt v="date" cur={when} set={setWhen} testid="milestone-when-date">Choose a previous date</Opt>
          {when === "date" && <Input type="date" max={today} value={day} onChange={(e) => setDay(e.target.value)} className="h-11" data-testid="milestone-when-date-input" />}
          {first && <Opt v="unknown" cur={when} set={setWhen} testid="milestone-when-unknown">I don't know the date <span className="text-slate-500">(you can add it later)</span></Opt>}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button disabled={!ok} onClick={save} className="bg-[#0A1F44] text-white" data-testid="milestone-achieve-save">Save</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
